import { abilitiesPlugin } from "@casl/vue";
import Vue from "vue";
import { ability } from "./abilities";

Vue.use(abilitiesPlugin, ability);
